export const particles = [
	{
		text: "から",
		attachesTo: ["noun", "verb", "te", "ii", "i-type", "desu"],
	},
	{
		text: "は",
		attachesTo: ["noun", "te", "na-type"],
	},
	{
		text: "も",
		attachesTo: ["noun", "verb", "te"],
	},
	{
		text: "が",
		attachesTo: ["noun", "verb", "i-type", "na-type", "desu"],
	},
	{
		text: "を",
		attachesTo: ["noun"],
	},
	{
		text: "に",
		attachesTo: ["noun", "na-type"],
	},
	{
		text: "へ",
		attachesTo: ["noun"],
	},
	{
		text: "で",
		attachesTo: ["noun"],
	},
	{
		text: "と",
		attachesTo: ["noun", "verb", "i-type", "na-type", "counter", "ii", "desu"],
	},
	{
		text: "こそ",
		attachesTo: ["noun", "verb", "ii", "i-type"],
	},
	{
		text: "さえ",
		attachesTo: ["noun", "verb"],
	},
	{
		text: "しか",
		attachesTo: ["noun", "verb"],
	},
	{
		text: "ばかり",
		attachesTo: ["noun", "verb"],
	},
	{
		text: "だけ",
		attachesTo: ["noun", "verb", "i-type", "na-type", "ii"],
	},
	{
		text: "のみ",
		attachesTo: ["noun", "verb", "i-type", "na-type", "ii"],
	},
	{
		text: "の",
		attachesTo: ["noun", "counter"],
	},
	{
		text: "な",
		attachesTo: ["na-type"],
	},
	{
		text: "か",
		attachesTo: ["desu"],
	},
	{
		text: "よ",
		attachesTo: ["desu"],
	},
	{
		text: "ね",
		attachesTo: ["desu"],
	},
]
